import React from 'react';
import { ApolloError } from '@apollo/client';

import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Pagination,
  IPaginationProps,
  LinearProgress,
  LoadedContent,
} from '@occc-app/design-system';
import { TransactionFragment } from '@occc/graphql';

import TransactionsListItem from './TransactionsListItem';

interface TransactionsTableProps {
  transactions?: TransactionFragment[];
  loading: boolean;
  error?: ApolloError;
  paginationProps: IPaginationProps;
  shouldShowFraudStatus: boolean;
  onFraudDetailsClick?: (transaction: TransactionFragment) => void;
}

export const TransactionsTable: React.FC<TransactionsTableProps> = ({
  transactions,
  loading,
  error,
  paginationProps,
  shouldShowFraudStatus,
  onFraudDetailsClick,
}) => {
  const renderData = (items: TransactionFragment[]) => {
    return (
      <>
        {loading && <LinearProgress />}
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Location</TableCell>
              <TableCell>Auth Code</TableCell>
              <TableCell align='right'>
                <Typography variant='subtitle2' noWrap>
                  $ Amount
                </Typography>
              </TableCell>
              <TableCell>Status</TableCell>
              {shouldShowFraudStatus && <TableCell>Fraud Status</TableCell>}
              <TableCell>Completed At</TableCell>
              <TableCell>Phone Number</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {items.map((transaction) => (
              <TransactionsListItem
                transaction={transaction}
                key={transaction.uuid}
                shouldShowFraudStatus={shouldShowFraudStatus}
                onFraudDetailsClick={onFraudDetailsClick}
              />
            ))}
          </TableBody>
        </Table>
        <Pagination {...paginationProps} />
      </>
    );
  };

  return (
    <LoadedContent<TransactionFragment>
      error={error}
      loading={loading}
      items={transactions}
      renderData={renderData}
    />
  );
};
